export const paymentMonth = payment => payment.salaryMonth || payment.transferResults?.[0]?.salaryMonth || payment.initiatedAt?.slice(0, 7) || '';
const retryable = status => ['failed', 'cancelled', 'canceled', 'reversed'].includes(String(status || '').toLowerCase());
export function employeeMonthPayment(history, employeeId, month) {
  const payments = history.filter(payment => ['individual', 'batch'].includes(payment.paymentType) && paymentMonth(payment) === month)
    .sort((a, b) => new Date(b.initiatedAt || 0) - new Date(a.initiatedAt || 0));
  let failed;
  for (const payment of payments) {
    const transfer = payment.transferResults?.find(item => item.employeeId === employeeId);
    if (transfer) {
      const result = { payment, transfer, status: retryable(transfer.status) ? 'Failed' : 'Paid' };
      if (result.status === 'Paid') return result;
      if (!failed) failed = result;
    } else if (!payment.transferResults?.length && payment.employeeIds?.includes(employeeId)) {
      const result = { payment, transfer: null, status: retryable(payment.status) ? 'Failed' : 'Paid' };
      if (result.status === 'Paid') return result;
      if (!failed) failed = result;
    }
  }
  return failed || { payment: null, transfer: null, status: 'Not Paid' };
}
export function defaultUnpaidMonth(employees, history, currentMonth) {
  const months = history.filter(payment => ['individual', 'batch'].includes(payment.paymentType))
    .map(paymentMonth).filter(month => /^\d{4}-(0[1-9]|1[0-2])$/.test(month)).sort();
  let month = months[months.length - 1] || currentMonth;
  if (!employees.length) return month;
  while (employees.every(employee => employeeMonthPayment(history, employee.employeeId, month).status === 'Paid')) {
    const [year, number] = month.split('-').map(Number);
    month = number === 12 ? `${year + 1}-01` : `${year}-${String(number + 1).padStart(2, '0')}`;
  }
  return month;
}
